module.exports = __webpack_public_path__ + "static/media/bac-noneOption.144bdbbd.svg";